import { render, staticRenderFns } from "./DeliveryConfigurationByUnitsEditor.vue?vue&type=template&id=5afe829d&"
import script from "./DeliveryConfigurationByUnitsEditor.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigurationByUnitsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports